/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShadowSubsystemAuditStepActivePayer } from './ShadowSubsystemAuditStepActivePayer';
import {
    ShadowSubsystemAuditStepActivePayerFromJSON,
    ShadowSubsystemAuditStepActivePayerFromJSONTyped,
    ShadowSubsystemAuditStepActivePayerToJSON,
    ShadowSubsystemAuditStepActivePayerToJSONTyped,
} from './ShadowSubsystemAuditStepActivePayer';

/**
 * 
 * @export
 * @interface ShadowSubsystemAuditStep
 */
export interface ShadowSubsystemAuditStep {
    /**
     * 
     */
    step: string;
    /**
     * 
     */
    detail: string;
    /**
     * 
     */
    active_payer?: ShadowSubsystemAuditStepActivePayer;
    /**
     * 
     */
    outcome: string;
    /**
     * 
     */
    passed?: boolean | null;
    /**
     * 
     */
    failure_outcome?: ShadowSubsystemAuditStepFailureOutcomeEnum;
    /**
     * 
     */
    ignored?: boolean;
}


/**
 * @export
 */
export const ShadowSubsystemAuditStepFailureOutcomeEnum = {
    No: 'NO',
    Unresolved: 'UNRESOLVED',
} as const;
export type ShadowSubsystemAuditStepFailureOutcomeEnum = typeof ShadowSubsystemAuditStepFailureOutcomeEnum[keyof typeof ShadowSubsystemAuditStepFailureOutcomeEnum];


/**
 * Check if a given object implements the ShadowSubsystemAuditStep interface.
 */
export function instanceOfShadowSubsystemAuditStep(value: object): value is ShadowSubsystemAuditStep {
    if (!('step' in value) || value['step'] === undefined) return false;
    if (!('detail' in value) || value['detail'] === undefined) return false;
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    return true;
}

export function ShadowSubsystemAuditStepFromJSON(json: any): ShadowSubsystemAuditStep {
    return ShadowSubsystemAuditStepFromJSONTyped(json, false);
}

export function ShadowSubsystemAuditStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemAuditStep {
    if (json == null) {
        return json;
    }
    return {
        
        'step': json['step'],
        'detail': json['detail'],
        'active_payer': json['active_payer'] == null ? undefined : ShadowSubsystemAuditStepActivePayerFromJSON(json['active_payer']),
        'outcome': json['outcome'],
        'passed': json['passed'] === undefined ? undefined : json['passed'] === null ? null : json['passed'],
        'failure_outcome': json['failure_outcome'] == null ? undefined : json['failure_outcome'],
        'ignored': json['ignored'] == null ? undefined : json['ignored'],
    };
}

export function ShadowSubsystemAuditStepToJSON(json: any): ShadowSubsystemAuditStep {
    return ShadowSubsystemAuditStepToJSONTyped(json, false);
}

export function ShadowSubsystemAuditStepToJSONTyped(value?: ShadowSubsystemAuditStep | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'step': value['step'],
        'detail': value['detail'],
        'active_payer': ShadowSubsystemAuditStepActivePayerToJSON(value['active_payer']),
        'outcome': value['outcome'],
        'passed': value['passed'],
        'failure_outcome': value['failure_outcome'],
        'ignored': value['ignored'],
    };
}

